import React from 'react'

interface ImportIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * Import icon component for uploading/importing data
 */
const ImportIcon: React.FC<ImportIconProps> = ({
  size = 16,
  color = 'white',
  className,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M12 10V12H3.99996V10H2.66663V12C2.66663 12.7333 3.26663 13.3333 3.99996 13.3333H12C12.7333 13.3333 13.3333 12.7333 13.3333 12V10H12ZM4.66663 6L5.60663 6.94L7.33329 5.22V10.6667H8.66663V5.22L10.3933 6.94L11.3333 6L7.99996 2.66667L4.66663 6Z'
        fill={color}
      />
    </svg>
  )
}

export default ImportIcon
